export const RouteLabels = {
    LOGIN: "login",
    REGISTER: "register",
    USER_LIST: "users",
    USER:"user",
    LICENSE: "license",
    LICENSE_LIST: "licenses",
    CUSTOMER: "customer",
    CUSTOMER_LIST: "customers",
    FEATURE: "feature",
    FEATURE_LIST: "features",
    ABOUT: "about",
    CONTACTUS: "contactus"
  };



// WEBPACK FOOTER //
// ./src/app/route-labels.ts